import Icon from './eye.svg?react'
import { createIcon } from './factory'

export const Eye = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
